import KeenSlider from 'keen-slider';

class ProductRecommendationsCarousel extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.slidesContainer = this.querySelector('.keen-slider');
    let cards = [...this.querySelectorAll('.carousel-card')];
    let dots = [...this.querySelectorAll('.course-dot')];

    new KeenSlider(this.slidesContainer, {
      slides: {
        perView: 1,
        spacing: 0,
        origin: 0,
      },
      created: (instance) => {
        dots.forEach((dot, index) => {
          dot.addEventListener('click', function () {
            instance.moveToIdx(index);
          });
        });
        let slideNum = instance.track.details.rel;
        cards.forEach((card, index) => {
          if (index === slideNum) {
            card.classList.add('active');
          } else {
            card.classList.remove('active');
          }
        });
      },
      slideChanged: (instance) => {
        let slideNum = instance.track.details.rel;
        dots.forEach((dot, index) => {
          if (index === slideNum) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
        cards.forEach((card, index) => {
          if (index === slideNum) {
            card.classList.add('active');
          } else {
            card.classList.remove('active');
          }
        });
      },
    });
  }
}

if (!customElements.get('product-recommendations-carousel'))
  customElements.define(
    'product-recommendations-carousel',
    ProductRecommendationsCarousel
  );
